export const TYPE_NONE = 0;
export const TYPE_OFFICE_UPDATE = 1;
export const TYPE_SHOP_UPDATE = 2;
export const TYPE_SHOP_DELETE = 3;

export const TYPE_HIME_UPDATE = 11;
export const TYPE_HIME_DELETE = 12;
export const TYPE_HIMESHOP_UPDATE = 13;
export const TYPE_HIMESHOP_DELETE = 14;

export const TYPE_RESV_CREATE = 21;
export const TYPE_RESV_UPDATE = 22;
export const TYPE_RESV_DELETE = 23;

export const TYPE_USER_UPDATE = 31;
export const TYPE_USER_DELETE = 32;
export const TYPE_USER_MERGE = 33;
export const TYPE_USERPOINT_UPDATEMANUAL = 34;

export const TYPE_SCHEDULEMEMO_UPDATE = 41;
export const TYPE_SCHEDULEMEMO_DELETE = 42;

export const TYPE_OFFICE_FIX_HIME = 51;
export const TYPE_OFFICE_FIXCANCEL_HIME = 52;
export const TYPE_OFFICE_FIXDAY_CREATE = 53;
export const TYPE_OFFICE_FIXDAY_CANCEL = 54;
export const TYPE_OFFICE_FIXDAY_REPLACEDATA = 55;

export const TYPE_STAFF_LOGIN = 61;
export const TYPE_STAFF_LOGOUT = 62;
